import React, { useState } from "react";
import { Button, message } from "antd";

export default function CopyLinkBtn({ text }) {
  const ellipsizeText = (text) => {
    return (
      text.substring(0, 12) +
      "...." +
      text.substring(text.length - 6, text.length)
    );
  };
  const link = `${process.env.REACT_APP_URL}${text?.collection_link}`;
  const [btnName, setBtnName] = useState(ellipsizeText(link));
  const copyLink = () => {
    navigator.clipboard.writeText(link);
    message.success("Link copied to clipboard");
  };

  return (
  
    <Button
      className="table-control"
      onMouseOver={() => setBtnName("Copy link")}
      onMouseLeave={() => setBtnName(ellipsizeText(link))}
      onClick={() => {
        copyLink();
      }}
      size="large"
      type="default"
      style={{
        width: "11.5em",
        fontSize:14
      }}
    >
      <span
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "center",
          maxWidth: "10.65em",
        }}
      >
        {btnName}
      </span>
    </Button>
    
  );
}
